import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';

type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
};

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: [],
    imports: [FormsModule]
})
export class ProfileComponent implements OnInit {
  profile: ProfileType | undefined;

  constructor(
    private http: HttpClient
  ) { }
  inputValue: string = '';
  storedValue: string | null = '';


  ngOnInit() {
    // localStorage.clear();
    this.getProfile(environment.apiConfig.uri);
    this.storedValue = localStorage.getItem('storedText');

  }

  getProfile(url: string) {
    this.http.get(url)
      .subscribe(profile => {
        this.profile = profile;
      });
  }


  saveToLocalStorage() {
    if (this.inputValue) {
      localStorage.setItem('storedText', this.inputValue);
      this.displayStoredValue();
    }
  }

  displayStoredValue() {
    this.storedValue = localStorage.getItem('storedText');
  }
}
